import Swiper from "swiper";
import { pad } from "./utils";

function positionCarousselArrow(swiperInstance) {
    const caroussel = swiperInstance.$el[0];
    const firstImage = caroussel.querySelector(".swiper-slide img");
    const arrow = caroussel.querySelector(".swiper-button-next > span");

    if (firstImage && arrow) {
        let imgOffset = firstImage.scrollHeight / 2;
        let arrowOffset = arrow.scrollHeight / 2;

        if (imgOffset > 0) {
            arrow.style.top = `${imgOffset - arrowOffset}px`;
        } else {
            arrow.style.top = `50%`;
        }
    }
}

function initStorySwiper() {
    const swiperElement = document.querySelector(".section-story-swiper .swiper-container");

    if (swiperElement) {
        let swiper = new Swiper(swiperElement, {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            allowSlidePrev: false,
            navigation: {
                nextEl: ".swiper-button-next"
            },
            breakpointsInverse: true,
            breakpoints: {
                600: {
                    spaceBetween: 20
                },
                900: {
                    spaceBetween: 49
                },
                1200: {
                    spaceBetween: 79
                }
            },
            on: {
                init: function() {
                    positionCarousselArrow(this);
                },
                resize: function() {
                    positionCarousselArrow(this);
                }
            }
        });
    }
}

function initHomeSwiper() {
    const swiperElement = document.querySelector(".section-home-hero .swiper-container");

    if (swiperElement) {
        let swiper = new Swiper(swiperElement, {
            loop: true,
            speed: 500,
            autoplay: {
                delay: 5000
            },
            // preloadImages: false,
            // lazy: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function(index, className) {
                    return '<span class="' + className + '">' + pad(index + 1, 3) + "</span>";
                }
            }
        });
    }
}

function initAboutColumnSwiper() {
    const swiperGalleryElement = document.querySelector(
        ".section-about-columns .swiper-gallery .swiper-container"
    );
    const swiperThumbsElement = document.querySelector(
        ".section-about-columns .swiper-thumbs .swiper-container"
    );

    if (swiperGalleryElement && swiperThumbsElement) {
        let slideCount = swiperGalleryElement.querySelectorAll(".swiper-slide").length;

        let gallery = new Swiper(swiperGalleryElement, {
            loop: true,
            speed: 600,
            slidesPerView: "auto",
            loopedSlides: slideCount,
            navigation: {
                nextEl: ".section-about-columns .swiper-gallery .swiper-button-next"
            }
        });

        let thumbs = new Swiper(swiperThumbsElement, {
            loop: true,
            speed: 600,
            slidesPerView: 3,
            spaceBetween: 20,
            loopedSlides: slideCount - 1,
            initialSlide: 1,
            on: {
                click: function(e) {
                    // Need to fake "slideToClickedSlide" to increase index with 1.
                    e.preventDefault();
                    gallery.slideTo(thumbs.clickedIndex + 1);
                }
            }
        });

        gallery.controller.control = thumbs;
        thumbs.controller.control = gallery;
    }
}

function initAboutTimelineSwiper() {
    const swiperImagesElement = document.querySelector(
        ".section-about-timeline .swiper-gallery .swiper-container"
    );
    const swiperTextElement = document.querySelector(
        ".section-about-timeline .swiper-text .swiper-container"
    );

    if (swiperImagesElement && swiperTextElement) {
        let images = new Swiper(swiperImagesElement, {
            loop: true,
            speed: 600,
            navigation: {
                prevEl: ".section-about-timeline .swiper-gallery .swiper-button-prev",
                nextEl: ".section-about-timeline .swiper-gallery .swiper-button-next"
            },
            pagination: {
                clickable: true,
                el: ".swiper-timeline",
                renderBullet: (index, className) => {
                    const year = swiperImagesElement
                        .querySelectorAll(".swiper-slide")
                        [index + 1].getAttribute("data-year");
                    return `<span class="${className}"><span>${year}</span></span>`;
                }
            }
        });

        let text = new Swiper(swiperTextElement, {
            loop: true,
            speed: 600,
            effect: "fade",
            autoHeight: true,
            breakpoints: {
                1024: {
                    autoHeight: false
                }
            }
        });

        images.controller.control = text;
        text.controller.control = images;
    }
}

export default function() {
    initStorySwiper();
    initHomeSwiper();
    initAboutColumnSwiper();
    initAboutTimelineSwiper();
}
